import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import axios from 'axios';

/** Fetch letter HTML and render on-screen (works with public or cookie auth). */
export default function IssuedLetterViewer({ previewUrl, title = 'Issued letter' }) {
  const [html, setHtml] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!previewUrl) return;
    let alive = true;
    setLoading(true);
    setError('');
    axios
      .get(previewUrl, { withCredentials: true, responseType: 'text' })
      .then((r) => {
        if (alive) setHtml(typeof r.data === 'string' ? r.data : String(r.data || ''));
      })
      .catch(() => {
        if (alive) setError('Could not load the letter. Try Download PDF if available.');
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => { alive = false; };
  }, [previewUrl]);

  if (loading) {
    return (
      <div className="flex justify-center py-16" data-testid="issued-letter-loading">
        <Loader2 className="h-7 w-7 animate-spin text-[#F15A22]" />
      </div>
    );
  }

  if (error || !html) {
    return (
      <p className="py-8 text-center text-sm text-stone-500" data-testid="issued-letter-error">
        {error || 'Letter preview unavailable.'}
      </p>
    );
  }

  return (
    <div className="space-y-3" data-testid="issued-letter-viewer">
      <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-[#7A8B9C]">
        {title}
      </p>
      <div className="overflow-hidden rounded-xl border border-[#D5DEE8] bg-white shadow-inner">
        <iframe
          title={title}
          srcDoc={html}
          className="h-[min(78vh,920px)] w-full bg-white"
          sandbox="allow-same-origin allow-popups"
        />
      </div>
    </div>
  );
}
